import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import logo from "../assets/dog-svgrepo-com.svg";
import { sharedNextPage } from "../utils/shared-functions";

export default function PageTitle({ text }) {

  const history = useHistory();
  const [hasToken, setHasToken] = useState(null);

  useEffect(() => {
    iniciar();
  }, []);

  const iniciar = async () => {
    try {

    } catch (err) {

      console.log('iniciar err');
      console.log(err);
    }
  }

  const navigateToLogin = () => {
    let obj = {};
    sharedNextPage("login", obj, history);
  };

  const navigateToDashboard = () => {
    sharedNextPage("login", {}, history);
  };

  return (
    <>
      <div className="flex justify-between pb-2" >
        <div className="flex flex-row items-center">
          <img
            height="32"
            width="32"
            alt="logo"
            src={logo}
          />
          <label className="pt-4 text-xl font-primary font-bold tracking-tight">
            {text}
          </label>
        </div>
        {hasToken === null &&
          <button className="px-6 py-2 text-white bg-blue-600 hover:bg-blue-700 font-semibold rounded-lg shadow-md transition duration-300"
            onClick={() => { navigateToLogin(); }}
          >
            Login
          </button>
        }
        {hasToken !== null &&
          <button className="px-6 py-2 text-white bg-blue-600 hover:bg-blue-700 font-semibold rounded-lg shadow-md transition duration-300"
            onClick={() => { navigateToDashboard(); }}
          >
            Dashboard
          </button>
        }
      </div>
      <hr />
    </>

  )
}
